module.exports = __webpack_public_path__ + "img/31.34b3eed7.png";